import React from 'react';

export default function UsageMeter({ label, used = 0, limit = null }) {
  const pct = limit && limit > 0 ? Math.min(100, Math.round((used / limit) * 100)) : 0;
  const atLimit = limit && limit > 0 && used >= limit;
  const barColor = atLimit ? 'bg-red-500' : pct > 80 ? 'bg-amber-500' : 'bg-blue-600';

  return (
    <div className="space-y-1">
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">{label}</span>
        <span className={atLimit ? 'text-red-600 font-medium' : ''}>
          {used} / {limit ?? '∞'}
        </span>
      </div>
      {limit != null && limit > 0 && (
        <div className="h-2 rounded-full bg-muted overflow-hidden">
          <div className={`h-full ${barColor} transition-all`} style={{ width: `${pct}%` }} />
        </div>
      )}
    </div>
  );
}
